
const knisaMainHE = {
  "knisa_main_title": "תעודות כניסה",
  "knisa_main_search_placeholder": "חיפוש תעודה",
  "knisa_main_button_new": "הוספת כניסה",
}

const knisaCreatePageHE = {
  "knisa_create_page_title": "כניסה חדשה",
  "knisa_create_page_title_ids": "כניסה: {{id}}",
  "knisa_create_page_search_placeholder": "חיפוש",
  "knisa_create_page_back": "חזרה",
  "knisa_create_page_addItem": "הוסף פריט",
  "knisa_create_page_editTitle_aria": "עריכת כותרת כניסה",
  "knisa_create_divide_modal_title": "{{entry}}-{{detail}} פיצול כניסה",
  "knisa_create_pallets_modal_title": "משטחים — כניסה {{entry}}-{{detail}}",
}

const knisaCreateTitleModalHE = {
  "knisa_create_modal_title_title": "כניסה חדשה",
  "knisa_create_modal_title_date": "תאריך",
  "knisa_create_modal_title_time": "שעה",
  "knisa_create_modal_title_grower": "מגדל",
  "knisa_create_modal_title_refference": "אסמכתא",
  "knisa_create_modal_title_carNum": "מספר רכב",
  "knisa_create_modal_title_carSelect": "בחר רכב",
  "knisa_create_modal_title_carClear": "ללא רכב",
  "knisa_create_modal_title_driver": "נהג",
  "knisa_create_modal_title_warehouse": "מחסן",
  "knisa_create_modal_title_teudaType": "סוג תעודה",
  "knisa_create_modal_title_remark": "הערה",
  "knisa_create_modal_title_saveTitle": "צור כניסה",
  "knisa_create_modal_title_continue": "המשך",
  "knisa_create_modal_title_referenceExistsForDate": "אסמכתא קיימת לתאריך {{date}}",
}

const knisaCreateProductModalHE = {
  "knisa_create_modal_product_title_create": "הוספת פריט לכניסה",
  "knisa_create_modal_product_title_edit": "עדכון פריט",
  "knisa_create_modal_product_externalEntry": "מספר כניסה חיצוני",
  "knisa_create_modal_product_externalPalletExists": "מספר זה כבר קיים",
  "knisa_create_modal_product_pallet": "משטח",
  "knisa_create_modal_product_qty": "כמות",
  "knisa_create_modal_product_product": "פריט",
  "knisa_create_modal_product_size": "גודל",
  "knisa_create_modal_product_package": "אריזה",
  "knisa_create_modal_product_weight": "משקל",
  "knisa_create_modal_product_price": "מחיר",
  "knisa_create_modal_product_detection": "איתור",
  "knisa_create_modal_product_expiryDate": "פג תוקף",
  "knisa_create_modal_product_copy": "העתק",
  "knisa_create_modal_product_multiplier": "כפולה",

  "knisa_create_modal_product_includeWeight": "ומשקל",
  "knisa_create_modal_product_createButton": "הוסף פריט",
  "knisa_create_modal_product_createPallet": "צור משטח",
  "knisa_create_modal_product_readScale_aria": "קריאת משקל מהמאזניים",
}

const knisaCreateElementHE = {
  "knisa_create_element_swipe_edit": "עדכון",
  "knisa_create_element_swipe_delete": "מחיקה",
  "knisa_create_element_swipe_divide": "פצל",
  "knisa_create_element_netto": "נטו",
  "knisa_create_element_brutto": "ברוטו",
  "knisa_create_element_print_aria": "הדפסה",
}

const knisaNotificationsHE = {
  "knisa_notification_printPalletSuccess": "משטח מספר {{num}} הודפס בהצלחה",
  "knisa_notification_printEntrySuccess": "כניסה מספר {{num}} הודפס בהצלחה",
  "knisa_create_mass_print_title": "הדפסת מדבקות",
  "knisa_create_mass_print_message": "האם אתם בטוחים שברצונכם להדפיס את כל המדבקות בבת אחת?",
  "knisa_create_mass_print_confirm": "הדפסה",
  "knisa_create_mass_print_printing": "...מדפיס",
  "knisa_notification_massPrintSuccess": "כל המדבקות הודפסו בהצלחה",
  "knisa_notification_growerHasNoProduct": "לספק זה אין את הפריט שנבחר",
  "knisa_notification_massPrintFailure": "אחת או יותר מהמדבקות לא הודפסו - נסה שוב",
  "knisa_notification_printEntryFailure": "כישלון בהדפסת כניסה מספר {{num}}",
  "knisa_notification_genericError": "משהו השתבש",
  "knisa_notification_entryUpdated": "הכניסה עודכנה בהצלחה",
  "knisa_notification_referenceExists": "אסמכתא כבר נקלטה בתאריך {{date}}",
  "knisa_notification_cannotDeletePicked": "לא ניתן למחוק כניסה שכבר נשלפה",
  "knisa_notification_palletDeleted": "המשטח נמחק בהצלחה",
  "knisa_notification_entryDeleted": "הכניסה נמחקה בהצלחה",
  "knisa_notification_cannotDivide": "לא ניתן לפצל",
}

export const knisaTranslationHE = {
  knisa: {
    ...knisaMainHE,
    ...knisaCreatePageHE,
    ...knisaCreateTitleModalHE,
    ...knisaCreateProductModalHE,
    ...knisaCreateElementHE,
    ...knisaNotificationsHE
  }
}